module.exports = __webpack_public_path__ + "static/media/greenstar.d98da5a4.webp";